var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            "dialog-class": "klippa-data-application-modal",
            "hide-footer": "",
            size: "xl",
            title: "Erkannte Informationen",
          },
          on: {
            hide: function ($event) {
              return _vm.reset()
            },
          },
          model: {
            value: _vm.isModalOpen,
            callback: function ($$v) {
              _vm.isModalOpen = $$v
            },
            expression: "isModalOpen",
          },
        },
        [
          _vm.isLoading
            ? _c(
                "div",
                {
                  staticClass:
                    "loading-overlay d-flex justify-content-center pt-5",
                },
                [_c("csp-loading-indicator")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isLoading
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "6" } },
                    [
                      _vm.fileId
                        ? _c("csp-record-data-application-form-preview", {
                            ref: "recordDataApplicationFormPreview",
                            attrs: {
                              "file-id": _vm.fileId,
                              "form-fields": _vm.formContext.complexFields,
                              "record-id": _vm.recordId,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "6" } },
                    [
                      _c(
                        "csp-desktop-info-card",
                        {
                          attrs: { cols: 12, "form-context": _vm.formContext },
                          on: { "cancel-form": _vm.reset, save: _vm.save },
                        },
                        [
                          _c("csp-record-data-application-vehicle-sub-form", {
                            attrs: { "form-context": _vm.formContext },
                            on: {
                              "field-hover-changed": _vm.onFieldHoverChanged,
                              "field-inclusion-changed":
                                _vm.onFieldInclusionChanged,
                            },
                          }),
                          _vm._v(" "),
                          _c("csp-record-data-application-customer-sub-form", {
                            attrs: { "form-context": _vm.formContext },
                            on: {
                              "field-hover-changed": _vm.onFieldHoverChanged,
                              "field-inclusion-changed":
                                _vm.onFieldInclusionChanged,
                            },
                          }),
                          _vm._v(" "),
                          _c("csp-record-data-application-cost-unit-sub-form", {
                            attrs: {
                              "file-id": _vm.fileId,
                              "form-context": _vm.formContext,
                              "record-id": _vm.recordId,
                            },
                            on: {
                              "field-hover-changed": _vm.onFieldHoverChanged,
                              "field-inclusion-changed":
                                _vm.onFieldInclusionChanged,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }